import React from 'react';

import ArticleEdit from '../articles/ArticleEdit';

const NewsEdit = props => (
	<ArticleEdit {...props} />
);

export default NewsEdit;
